export { numberFormatters } from "./number.formatter"
export { formatDate } from "./date.formatters"  

export const capitalized = (string: String | string | null | undefined): string => {
  if (!string || typeof string !== 'string') {
    return '';
  }
  return string.charAt(0).toLocaleUpperCase() + string.slice(1);
}
